import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, observable, Observable } from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpotlightService {
  public routeToQALobby=new BehaviorSubject(false);
  private isMotionGraphicsCompleted: boolean;

  constructor(private http: HttpClient) { }

  setIsMotionGraphicsCompleted(isMotionGraphicsCompleted: boolean): void {
    this.isMotionGraphicsCompleted = isMotionGraphicsCompleted;
  }

  getIsMotionGraphicsCompleted(): boolean {
    return this.isMotionGraphicsCompleted;
  }

  getData(): Observable<any>
  {
    const url = environment.apiURL + 'api/cinejoy/getPremieresList';
    return this.http.get(url);
  }

  getAllSpotlightData(): Observable<any>
  {
    const url = environment.apiURL + 'api/cinejoy/spotlight/event/active-events';
    return this.http.get(url);
  }

  getArchiveData(): Observable<any>
  {
    const url = environment.apiURL + 'api/cinejoy/getArchiveSpotlights';
    return this.http.get(url);
  }


  getUserDetails(): Observable<any> {
    const url = environment.apiURL + 'api/user-profile/public-view';
    return this.http.get(url, { withCredentials: true });
  }
  getStreamLink(vimeoStreamLink: any, frameWidth: any, frameHeight: any): Observable<any> {
    const url = `https://vimeo.com/api/oembed.json?url=${vimeoStreamLink}&width=${frameWidth}&height=${frameHeight}`;
    return this.http.get(url);
  }
  getPremierdeatails(eventId: any): Observable<any> {
    const url =  environment.apiURL + `api/cinejoy/getPremieresDetails/${eventId}`;
    return this.http.get(url);
  }

  getEmojiCount(eventId: any): Observable<any> {
    const url =  environment.apiURL + `api/${eventId}/RED_CARPET/comment`;
    return this.http.get(url);
  }

  postEmojiCount(countData: any, eventId: any): Observable<any> {
    const url =  environment.apiURL + `api/${eventId}/RED_CARPET/comment`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(url, countData, {headers});
  }

  getTheaterPageEmojiCount(event_id: any): Observable<any> {
    const url = environment.apiURL + `api/${event_id}/THEATER/comment`;
    return this.http.get(url);
  }

  postTheaterEmojiCount(countData: any, event_id: any): Observable<any> {
    const url = environment.apiURL + `api/${event_id}/THEATER/comment`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(url, countData, {headers});
  }

  fetchTalkJsMetadata(): Observable<any> {
    const url = environment.apiURL + 'api/talk-js-metadata';
    return this.http.get(url, {withCredentials: true});
  }

  getAgilitixStreamingLink(eventId: any): Observable<any>{
    const url = environment.apiURL + `api/v2/agiletix/customer/get/streaming/${eventId}`;
    return this.http.get(url, {withCredentials: true});
  }

  getMovieInfo(eventId): Observable<any>{
    const url = environment.apiURL + `cinejoy/getMovieDetails/${eventId}`;
    return this.http.get(url, {withCredentials: true});
  }
  getMovieDetails(eventId): Observable<any>{
    const url = environment.apiURL + `api/cinejoy/spotlight/event/${eventId}`;
    return this.http.get(url, {withCredentials: true});
  }

  getScreeningPartyList():Observable<any>{
    const url = environment.apiURL + `api/screening-party`;
    return this.http.get(url, {withCredentials: true});
  }


}
